// assets/tabs.js
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-tabs]').forEach(container => {
    const buttons = container.querySelectorAll('[data-tab]');
    const panels  = container.querySelectorAll('[data-panel]');

    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        const idx = btn.getAttribute('data-tab');
        // Hide all panels and remove active from all buttons
        panels.forEach(p => p.classList.add('hidden'));
        buttons.forEach(b => b.classList.remove('border-b-2','border-primary'));

        // Show the corresponding panel and activate the button
        panels[idx].classList.remove('hidden');
        btn.classList.add('border-b-2','border-primary');
      });
    });
  });
});
